module.exports = __webpack_public_path__ + "img/banner2.f2d58afb.png";